import React from 'react';

import { statusColor } from '../../constants';
import styles from './Badge.module.scss';

export const Badge = ({ children, variant = 'default', style: sx = {}, className = '' }) => (
  <span
    className={`${styles.badge} ${styles[variant] || styles.default} ${className}`.trim()}
    style={sx}
  >
    {children}
  </span>
);

export const StatusDot = ({ status, size = 8 }) => (
  <span
    className={styles.statusDot}
    style={{
      '--dot-size': `${size}px`,
      '--dot-color': statusColor[status] || '#D4D4D8',
    }}
  />
);
